import type { Span, SpanProcessor } from "@opentelemetry/sdk-trace-web";

export class BrowserAttributesSpanProcessor implements SpanProcessor {
    onStart(span: Span) {
        const { href, pathname, search, hash, hostname } = window.location;

        span.setAttributes({
            "page.url": href,
            "page.hostname": hostname,
            "page.route": pathname,
            "page.hash": hash,
            "page.search": search,
            "browser.width": window.innerWidth,
            "browser.height": window.innerHeight,
        });
    }

    onEnd() {}

    forceFlush() {
        return Promise.resolve();
    }

    shutdown() {
        return Promise.resolve();
    }
}
